module.exports = __webpack_public_path__ + "static/media/1.a8743b1f.gif";